<template>
  <div class="filter-group" :class="{ 'is-root': depth === 0 }" :style="groupStyle">
    <div class="group-header">
      <div class="group-logic">
        <el-radio-group v-model="group.logic" size="mini">
          <el-radio-button label="AND">满足以下所有条件</el-radio-button>
          <el-radio-button label="OR">满足以下任一条件</el-radio-button>
        </el-radio-group>
        <el-button
          v-if="depth > 0"
          icon="el-icon-close"
          circle
          size="mini"
          type="danger"
          class="remove-group-btn"
          @click="$emit('remove-node', { parentGroup, index })"
        />
      </div>
    </div>

    <div class="group-body">
      <div class="group-line" v-if="depth > 0"></div>
      <div class="group-children">
        <template v-for="(child, idx) in group.children">
          <cohort-filter-group
            v-if="child.type === 'group'"
            :key="'g-' + idx"
            :group="child"
            :depth="depth + 1"
            :parentGroup="group"
            :index="idx"
            :diseaseDict="diseaseDict"
            v-on="$listeners"
          />
          <cohort-filter-item
            v-else
            :key="'c-' + idx"
            :item="child"
            :parentGroup="group"
            :index="idx"
            :diseaseDict="diseaseDict"
            @remove="handleRemoveItem(group, idx)"
            @field-change="(item, field) => $emit('field-change', item, field)"
            @operator-change="(item, op) => $emit('operator-change', item, op)"
          />
        </template>
      </div>
    </div>

    <div class="group-actions">
      <el-button size="mini" icon="el-icon-plus" @click="$emit('add-condition', group)">添加条件</el-button>
      <el-button size="mini" icon="el-icon-circle-plus-outline" @click="$emit('add-group', group)">添加子条件组</el-button>
    </div>
  </div>
</template>

<script>
import CohortFilterItem from './CohortFilterItem.vue';

export default {
  name: 'CohortFilterGroup',
  components: { CohortFilterItem },
  props: {
    group: { type: Object, required: true },
    depth: { type: Number, default: 0 },
    parentGroup: { type: Object, default: null },
    index: { type: Number, default: -1 },
    diseaseDict: { type: Object, default: () => ({}) }
  },
  computed: {
    groupStyle() {
      return {
        marginLeft: this.depth > 0 ? '12px' : '0'
      };
    }
  },
  methods: {
    handleRemoveItem(parentGroup, index) {
      this.$emit('remove-node', { parentGroup, index });
    }
  }
};
</script>

<style lang="less" scoped>
.filter-group {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 8px 8px 4px;
  margin-bottom: 6px;
  background: #fff;

  &.is-root {
    border: 1px solid #4da3c0;
    background: #fafcfe;
  }

  .group-header {
    margin-bottom: 6px;
    .group-logic {
      display: flex;
      align-items: center;
      gap: 8px;
      .el-radio-button__inner {
        padding: 5px 10px;
      }
      .remove-group-btn {
        flex-shrink: 0;
      }
    }
  }

  .group-body {
    position: relative;
    .group-line {
      position: absolute;
      left: -8px;
      top: 0;
      bottom: 12px;
      width: 2px;
      background: #dcdfe6;
      border-radius: 1px;
    }
    .group-children {
      padding-left: 4px;
    }
  }

  .group-actions {
    margin-top: 4px;
    padding-top: 4px;
    display: flex;
    gap: 6px;
    border-top: 1px dashed #ebeef5;
  }
}
</style>
